var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.8,2.7C116.3,2.7,3.3,115.7,3.3,255.2s113,252.5,252.5,252.5s252.5-113,252.5-252.5S395.2,2.7,255.8,2.7z  M255.8,494C123.9,494,17,387.1,17,255.2S123.9,16.4,255.8,16.4s238.8,106.9,238.8,238.8S387.7,494,255.8,494z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.5,297.5c-15.7,0-29.8,6.5-39.9,16.9l-76.7-42c1.8-5.5,2.8-11.3,2.8-17.3c0-6.8-1.3-13.3-3.5-19.3l76-41.6 c10.2,11.3,24.9,18.5,41.3,18.5c30.7,0,55.6-24.9,55.6-55.6s-24.9-55.6-55.6-55.6c-30.7,0-55.6,24.9-55.6,55.6 c0,6.2,1,12.1,2.9,17.6l-76.6,41.9c-10.1-10.6-24.3-17.2-40.1-17.2c-30.7,0-55.6,24.9-55.6,55.6s24.9,55.6,55.6,55.6 c16.5,0,31.4-7.3,41.5-18.7l75.9,41.5c-2.3,6.1-3.6,12.7-3.6,19.6c0,30.7,24.9,55.6,55.6,55.6c30.7,0,55.6-24.9,55.6-55.6 S365.2,297.5,334.5,297.5z M334.5,122.9c19,0,34.4,15.4,34.4,34.4s-15.4,34.4-34.4,34.4c-19,0-34.4-15.4-34.4-34.4 S315.5,122.9,334.5,122.9z M165.1,289.6c-19,0-34.4-15.4-34.4-34.4s15.4-34.4,34.4-34.4s34.4,15.4,34.4,34.4 S184.1,289.6,165.1,289.6z M334.5,387.5c-19,0-34.4-15.4-34.4-34.4c0-19,15.4-34.4,34.4-34.4c19,0,34.4,15.4,34.4,34.4 C368.9,372.1,353.5,387.5,334.5,387.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.78220993b30b5ad7152b4bb5867da6f5.svg";
export { ForwardRef as ReactComponent };